var SPiD = this.SPiD || {};
SPiD.validate = SPiD.validate || {};

/**
 * Extract data from a form. Given a form, SPiD.validate.extractData will return
 * an object describing all data entered into it. Any input, select and textarea
 * elements with data in them will be serialized into an object:
 *
 * <form>
 *   <div class='form-element'>
 *     <label for='email'>
 *       E-post
 *       <input type='email' name='email' value='christian@kodemaker.no' id='email' class='input'>
 *     </label>
 *   </div>
 *   <div class='form-element'>
 *     <label for='email'>
 *       Passord
 *       <input type='password' name='password' id='password' class='input'>
 *     </label>
 *   </div>
 *   <div class='form-element'>
 *     <label class='faded'>
 *       <input type='checkbox' name='remember-me' checked>
 *       Hold meg innlogget
 *     </label>
 *   </div>
 *   <div class='form-element'>
 *     <input type='submit' class='btn-primary' value='Logg inn'>
 *   </div>
 *   <a href='/glemt-passord.html'>Glemt passordet?</a>
 * </form>
 *
 * Will result in the object:
 *
 *     {email: 'christian@kodemaker.no', 'remember-me': 'on'}
 *
 * Fields with no value (or with only blank strings, e.g. ' ') are not included
 * in the extracted data.
 *
 * Extracting data this way opens up for several interesting applications. The
 * intended use here is a form/data validation system that is not coupled to the
 * DOM, but this would easily be usable to build query strings for synthetisized
 * GET requests, or sending the resulting object as JSON with an XMLHttpRequest,
 * persisting state in localStorage etc etc.
 */

(function () {
    'use strict';

    var useValue = function (input) {
        if (input.type === 'submit') { return false; }
        if (input.type === 'radio' || input.type === 'checkbox') { return input.checked; }
        return !!input.value && !!input.name;
    };

    var getValue = {
        input: function (input) {
            if (useValue(input)) { return input.value; }
        },

        textarea: function (textarea) {
            if (textarea.innerHTML) { return textarea.innerHTML; }
        },

        select: function (select) {
            var val = select.options[select.selectedIndex].value;
            if (val) { return val; }
        }
    };

    SPiD.validate.extractData = function (form) {
        return SPiD.validate.getInputs(form).reduce(function (data, el) {
            var val = getValue[el.tagName.toLowerCase()](el);
            if (val) { SPiD.setPath(data, el.name, val.trim()); }
            return data;
        }, {});
    };

}());
